import { customContactUsForm } from "@hardware/Services/ContactUsService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

const capitalize = (word: string) => word[0].toUpperCase() + word.slice(1);

replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState().components.contactUsForm as any;
    const formData = {
        emailTo: props.parameter.emailRecipients,
    } as any;

    for (const key in state.fieldValues) {
        const value = state.fieldValues[key];
        if (value) {
            if (capitalize(key) === "Brands") {
                formData[capitalize(key)] = value.split(",");
                continue;
            }
            if (capitalize(key) === "ValueAddedServices") {
                formData[capitalize(key)] = value.split(",");
                continue;
            }
            formData[capitalize(key)] = value;
        }
    }

    const authKey = formData["Email"] + formData["FullName"];
    props.apiParameter = {
        emailTo: props.parameter.emailRecipients,
        AuthKey: authKey,
        ...formData,
    };
});

replaceInChain(chain, SendDataToApi, async props => {
    await customContactUsForm(props.apiParameter, props.parameter.emailRecipients);
});
